import { useNavigate } from 'react-router-dom';
import Container from '../components/ui/Container/Container';
import PageHeading from '../components/ui/PageHeading/PageHeading';
import OrganizationsList from '../components/Organizations/OrganizationsList';
import { Route } from '../routes';


const OrganizationsPage: React.FC = () => {
  const navigate = useNavigate();

  const addHandler = () => {
    navigate(Route.organization("add"));
  }

  return (
    <>
    <PageHeading onAdd={addHandler} backTo={Route.settings}>Agents</PageHeading>
    <Container>
      <OrganizationsList />
    </Container>
    </>
  )
}

export default OrganizationsPage;
